import React from 'react';
import "./Caract__style.scss"

export default function Elementaire({ item, hatImage, cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage}) {
    const images = {
      pdv: require("./../../../Asset/Stuff/pct.19f83f93.png"),

    cc: require("./../../../Asset/Stuff/cc.png"),
    agi: require("./../../../Asset/Stuff/agi.png"),
    chance: require("./../../../Asset/Stuff/chance.png"),
    force: require("./../../../Asset/Stuff/force.png"),
    intel: require("./../../../Asset/Stuff/intel.png"),
    sasa: require("./../../../Asset/Stuff/saas.png"),
    pui: require("./../../../Asset/Stuff/pui.png"),
    doCrit: require("./../../../Asset/Stuff/doCrit.png"),
    doPou: require("./../../../Asset/Stuff/doPou.png"),
    doNeutre: require("./../../../Asset/Stuff/doNeutre.png"),
    };

  const getTotalCaractValue = (items, type) => {
    return items.reduce((total, item) => {
      if (item && Array.isArray(item.effects)) {
        const effect = item.effects.find((effect) => effect.type.name === type);
        if (effect) {
          return total + (effect.int_maximum || 0);
        }
      }
      return total;
    }, 0);
  };

  return (
    <div className="stats__style">
      <div className="stats__wrapper">
        <div className="stats pv">
          <div className="elem__stats__left">
            <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Vitalité') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Vitalité')} </div><span><img src={images.pdv} alt="" /></span> Vitalité
          </div>
        </div>
        <div className="stats sasa">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Sagesse') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Sagesse')} </div><span><img src={images.sasa} alt="" /></span> Sagesse
          </div>
        </div>
        <div className="stats force">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Force') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Force')} </div><span><img src={images.force} alt="" /></span> Force
          </div>
        </div>
        <div className="stats intel">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Intelligence') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Intelligence')} </div> <span><img src={images.intel} alt="" /></span> Intel
          </div>
        </div>
        <div className="stats chance">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Chance') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Chance')} </div><span><img src={images.chance} alt="" /></span> Chance
          </div>
        </div>
        <div className="stats agi">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Agilité') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Agilité')} </div><span><img src={images.agi} alt="" /></span> Agilité
          </div>
        </div>
        <div className="stats pui">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Puissance') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Puissance')} </div><span><img src={images.pui} alt="" /></span> Puissance
          </div>
        </div>
      </div>     
      <div className="stats__wrapper">
        <div className="stats doCrit">
          <div className="elem__stats__left">
            <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Critiques') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Critiques')} </div><span><img src={images.doCrit} alt="" /></span> Do Crit
          </div>
        </div>
        <div className="stats doPou">
          <div className="elem__stats__left">
            <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Poussée') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Poussée')} </div><span><img src={images.doPou} alt="" /></span> Do Pou
          </div>
        </div>
        <div className="stats doForce">
          <div className="elem__stats__left">
            <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Terre') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Terre')} </div><span><img src={images.force} alt="" /></span> Do Force
          </div>
        </div>
        <div className="stats doIntel">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Feu') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Feu')} </div><span><img src={images.intel} alt="" /></span> Do Intel
          </div>
        </div>
        <div className="stats doChance">
          <div className="elem__stats__left">
             <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Eau') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Eau')} </div><span><img src={images.chance} alt="" /></span> Do Chance
          </div>
        </div>
        <div className="stats doAgi">
          <div className="elem__stats__left">
            <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Vitalité') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Air')} </div><span><img src={images.agi} alt="" /></span> Do Agilité
          </div>
        </div>
        <div className="stats doNeutre">
          <div className="elem__stats__left">
            <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Neutre') > 0 ? "left__number" : "left__number0"}>
            {getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Dommages Neutre')} </div><span><img src={images.doNeutre} alt="" /></span> Do Neutre
          </div>
        </div>
      </div>     
    </div>
  );
}
